const defaultNetworkError = {
    code: 'network_error',
    userFriendlyError: {
        title: 'Could Not Connect To Server',
        detail: 'There was an error connecting to our servers. Please try again in a few seconds.',
    },
};

const networkErrors = {
    default: defaultNetworkError,
    ECONNREFUSED: defaultNetworkError,
    ECONNRESET: defaultNetworkError,
    ETIMEDOUT: defaultNetworkError,
    EHOSTUNREACH: defaultNetworkError,
    ENOTFOUND: defaultNetworkError,
    EAI_AGAIN: defaultNetworkError,
};

const serverErrors = {
    internal_server_error: {
        code: 'internal_server_error',
        userFriendlyError: {
            title: 'Error',
            detail: 'An unknown error occurred. Please try again.',
        },
    },
};

const responseErrors = {
    unknown_error: {},
};

const parsingErrors = {
    non_json_response_received: {},
};

const flowErrors = {
    refresh_access_token_failure: {},
    refresh_access_token_repeated_failure: {},
    not_logged_in: {},
};

export { networkErrors, serverErrors, responseErrors, parsingErrors, flowErrors };
